/* eslint semi: 1 */

export const LICENSE_STATUS_ICON = {
  OK: 'ok',
  /**
  * The license state is UNMOVABLE.
    */
  LOCKED: 'locked'
};
